import * as types from './actionTypes';  
import orderApi from '../api/orderApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doOrder(data) {

  return {
    type: types.DO_ORDER, 
    data
  };
}

export function doOrderRes(data) {  
  return {
    type: types.DO_ORDER_RES, 
    data
  };
}

export function get_order(data) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      orderApi.doOrder(data).then(data => {
        dispatch(doOrderRes(data));
        dispatch(doOrderRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}